var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.msg.chatType === _vm.CHAT_TYPE.ANSWER
    ? _c("answer", {
        attrs: {
          lastMsg: _vm.lastMsg,
          isWaitAnswer: _vm.isWaitAnswer,
          "show-portrait": _vm.fullscreen,
          fullscreen: _vm.fullscreen,
          msg: _vm.msg,
        },
        on: {
          resend: function (val) {
            return _vm.$emit("resend", val)
          },
          submit: function (data) {
            return _vm.$emit("submit", data)
          },
          scrollToEnd: function ($event) {
            return _vm.$emit("scrollToEnd")
          },
        },
      })
    : _vm.msg.chatType === _vm.CHAT_TYPE.QUESTION
    ? _c("question", {
        attrs: {
          "show-portrait": _vm.fullscreen,
          fullscreen: _vm.fullscreen,
          msg: _vm.msg,
        },
      })
    : _c("div", { staticClass: "system-msg" }, [
        _vm._v(_vm._s(_vm.msg.content)),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }